// eslint-disable-next-line import/no-anonymous-default-export
export default {
  OnlineScreen: 'HitPaw Online Gravador de Tela ',
  RecordScreenWithAudio:
    'Gravar tela inteira, janela de aplicação, ou uma aba do navegador com áudio',
  ScreenOnly: 'Somente Tela',
  ScreenAndCam: 'Tela & Webcam',
  Microphone: 'Microfone',
  SystemAudio: 'Áudio do Sistema',
  StartRecording: 'Começar a Gravar',
  NoAudioAndTryAgain:
    'Não há fonte de áudio disponível. Por favor, siga <1><0>as instruções</0></1> abaixo e tente novamente.',
  TheInstruction: 'as instruções',
  AccessMicrophone:
    'online.hitpaw.com.br precisa acessar seu Microfone para gravar áudio, por favor, permitia-o.',
  BestScreenRecorderSoftware:
    'Melhor Gravador de Tela e Software de Streaming de Vídeo Gratuito',
  CaptureAnythingOnScreen:
    'Capturar e gravar seus sites, palestras, chamadas de vídeo e qualquer coisa na tela',
  RecordToShare:
    'Gravar seus destaques de jogo para compartilhar com os amigos',
  StreamOnFackbook:
    'Transmitir no Facebook, YouTube, Twitch, etc. como um profissional',
  BringMagic:
    'Trazer a webcam virtual mágica para transmissões ao vivo e chamada de vídeo',
  StepOne: 'Passo 1: Escolha a tela que deseja gravar.',
  StepTwo: 'Passo 2: Clique em “Compartilhar áudio do sistema”.',
  StepThree: 'Passo 3: Clique em “Compartilhar” e comece a gravar.',
  StepFour: 'Passo 2: Clique em “Compartilhar” e comece a gravar.',
  GrantPermission: 'Conceda permissão para gravação de tela e tente novamente.',
  RecordingProgress: 'Gravação em andamento...',
  MoreOptions: 'Mais Opções de Gravação:',
  Pause: 'Pausar',
  Continue: 'Continuar',
  Stop: 'Parar',
  Webcam: 'Webcam',
  GreenScreenAndChangeBackground: 'Tela verde e alterar o plano de fundo',
  StreamToYouTube: 'Transmitir para o Facebook, Twitch, YouTube, etc.',
  ScheduleRecording: 'Gravação Temporizada',
  NewRecording: 'Nova Gravação',
  ExportToMp4: 'Exportar para MP4',
  AddWatermark: "Adicionar uma Marca D'água",
  ChangeSpeed: 'Alterar Velocidade',
  CutAndTrim: 'Cortar e Recortar',
  '120XDownload': 'Conversor de vídeo 120X mais rápido e baixador de vídeo HD',
  CovertAudioFormats:
    'Converter arquivos de vídeo e áudio para mais de 1000 formatos',
  DownloadVideoFromWebsites:
    'Baixar e salvar vídeos de mais de 10.000 sites de compartilhamento de vídeo',
  BatchConvertImageAndGif:
    'Converter imagens em lote e criar GIFs a partir de vídeos',
  RichEdingingFeatures:
    "Recursos avançados de edição de vídeo integrados: mesclar, cortar, recortar, marca d'água etc.",
  BestVideoEditor: 'Melhor editor de vídeo projetado para múltiplos propósitos',
  MakeSimpleEdits:
    'Um editor de vídeo premiado para simplificar edições complexas.',
  BeyondImaginationMaterials:
    'Vários materiais integrados e online além da imaginação.',
  AqualityVideoMaker:
    'Um criador de vídeo orientado para a qualidade para exportar e compartilhar vídeos 1080P/4K completamente grátis.',
  WorkOnAnywhere:
    'Funcionar bem e com segurança em qualquer PC sem afetar seu desempenho.',
  RecordCompleted: 'Gravação Concluída',
  Download: 'Baixar',
  YouMayNeed: 'Você pode precisar',
  TryItFree: 'Testar Grátis',
  AlreadyHaveAccount: 'Já tens conta?',
  LoginNow: 'Entrar Agora',
  exceedTenMin: 'A gravação já atingiu 10 minutos.',
  UpgradeToRecord: 'Atualizar para continuar a gravação.',
  ScreenProFeature: 'HitPaw Online Gravador de Tela Pro.',
  FreeScreenAccount:
    'A conta gratuita tem apenas <1><0>10</0></1> minutos de tempo de gravação.',
  BuyNow: 'Compra Agora',
  DownloadMp4: 'Baixar Como MP4',
  FreeDownload: 'Baixar Grátis',
  DownloadTenMin: 'Baixar 10 Minutos',
  FullVideo: 'Vídeo Completo',
  FormatMp4: 'Formato Como MP4',
  Downloading: 'Baixando...',
  DownloadFailed: 'Falha ao baixar, tente novamente.',
  DownloadSuccess: 'Baixe com Sucesso!',
  Exceed100MDownloadConvert:
    'O tamanho do vídeo não pode exceder 100 MB para baixar o vídeo no formato MP4. Faça o download do HitPaw Video Converter para obter mais recursos.',
  Exceed30Min:
    'A duração do vídeo não pode exceder 30 minutos para baixar o vídeo no formato MP4. Faça o download do HitPaw Video Converter para obter mais recursos.',
  Week: 'Semanalmente',
  Month: 'Mensalmente',
  Year: 'Anualmente',
  BilledMonthly: 'Cobrado Anualmente',
  BilledAnnually: 'Cobrado Anualmente',
  ConvertText1:
    'Baixar a versão para desktop para processar arquivos grandes em lote sem limite de tamanho',
  ConvertText2:
    'Converter arquivos de vídeo e áudio em lote para mais de 1000 formatos com velocidade 120X mais rápida',
  ConvertText3:
    'Baixar e salvar vídeos de mais de 10.000 sites, como YouTube, TikTok, Instagram, etc.',
  ConvertText4:
    'Converter o Apple Music para MP3 com o DRM removido (somente na versão Windows)',
  TenMinUp: 'A gravação já atingiu 10 minutos.',
  UpgradeMore: 'Atualizar para continuar a gravação.',
  NoRecordLimit: 'Gravação de vídeo sem limite de tempo',
  NoRecordNumLimit: 'Gravação de vídeo sem limitação de número',
  DownloadVideoMP4: 'Baixe o Vídeo em  MP4',
  MonthOff: '60% OFF',
  YearOff: '80% OFF',
  UpgradeNow: 'Actualizar Agora',
  CheckConnect: 'Verifique sua conexão e tente novamente.',
};
